import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import { Link } from "gatsby";
const { ContentModule } = require("@starberry/gatsby-theme-utils/Modules/ContentModule");

import "./assets/styles/_index.scss";
import { PageLinks } from "../../common/site/page-static-links";

const Faqs = (props) => {
    return (
        <section className="faqs-wrapper section-p104">
            <Container>
                <Row>
                    <Col md={8}>
                        {props?.accordion_intro ? <ContentModule Content={props.accordion_intro?.data?.accordion_intro} /> : ""}
                    </Col>
                    <Col md={4} className="d-md-flex justify-content-end">
                        <Link to={`/${PageLinks.contact}/`} className="button button-outline">
                            Contact support
                        </Link>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Accordion className="accordion-module-section faqs-accordion">
                            <React.Fragment key="0">
                                {props?.add && props.add.map((item, index) => (
                                    <Accordion.Item eventKey={index}>
                                        <Accordion.Header>{item.title}</Accordion.Header>
                                        <Accordion.Body>
                                            {item?.content ? <ContentModule Content={item.content?.data?.content} /> : ""}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </React.Fragment>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Faqs;
